import React, { Suspense } from "react"
import Context from "./context"
import { BrowserRouter } from "react-router-dom"
import reducer, { initialState } from "./reducers/index"
import { basename, AppContextInterface } from "./const"
import Routes from "./Routes"
import { EnhancedString, log } from "./functions"
import Spinner from "./components/stateless/Spinner"

function useContextProps() {
    const [globalState, dispatch] = React.useReducer(reducer, initialState)
    function t(word: string): string
    function t(word: string, onlyString: boolean): string | EnhancedString

    function t(word: string, onlyString: boolean = true) {
        // console.log(globalState.w, word)
        // if you want to return EnhancedString, supply false as the second argument to t()
        // example: t("word", false)
        if (!onlyString) return globalState.w ? new EnhancedString(globalState.w[word]) : word
        else return globalState?.w[word]  ? globalState.w[word] : word
    }
    return { globalState, dispatch, t, log }
}

function App() {
    const { globalState, dispatch, t, log } = useContextProps()
    // console.log(t("wrong_password"))
    return (
        <div className="member">
            <Suspense fallback={<Spinner />}>
                <BrowserRouter basename={basename}>
                    <Context.Provider value={{ globalState, dispatch, t, log }}>
                        <Routes />
                    </Context.Provider>
                </BrowserRouter>
            </Suspense>
        </div>
    )
}

export { useContextProps }
export default App